import { defineMessages } from 'react-intl';

export default defineMessages({
  AUTO: {
    id: 'dashboard_home_tab.auto',
  },
  MRH: {
    id: 'dashboard_home_tab.mrh',
  },
  EPARGN: {
    id: 'dashboard_home_tab.epargn',
  },
  AMC: {
    id: 'dashboard_home_tab.amc',
  },
  ASI: {
    id: 'dashboard_home_tab.amc',
  },
  deconnexion: {
    id: 'deconnexion_button_title',
  },
  myAccount: {
    id: 'navbar.my_account',
  },
  addContracts: {
    id: 'navbar.add_contracts',
  },
  Particuliers: {
    id: 'navbar_login.particuliers',
  },
  Corporate: {
    id: 'navbar_login.corporate',
  },
  BesoinAide: {
    id: 'info_numero_police.header',
  },
  settingAccount: {
    id: 'setting.settingAccount',
  },
  arabic: {
    id: 'my_account.language.arabic',
  },
  french: {
    id: 'my_account.language.french',
  },
  service_assitance: {
    id: 'dashboard_home.service_assistance',
  },
  applez: {
    id: 'dashboard_home.Appelez',
  },
  appelezMrh: {
    id: 'dashboard_home.Appelez_mrh',
  },
  languages: {
    id: 'my_account.languages',
  },
  language: {
    id: 'my_account.language',
  },
});
